import {permissionTnpType} from "../../actions/permission/type";

const initialState = {
    actions: [],
    error: null
}
const permissionTnpActionReducer = (state = initialState, action) => {
    switch (action.type) {
        case permissionTnpType.LOAD_PERMISSIONS_TNP_DATA_START :
            return {
                ...state,
                params : action.params,
            }
        case permissionTnpType.SET_PERMISSIONS_TNP_SUCCESS:
            return {
                ...state,
                actions : action.params,
            }
        case permissionTnpType.SET_PERMISSIONS_TNP_ERROR:
            return {
                ...state,
                error: action.params,
            }
        default:
            return state;
    }
}

export default permissionTnpActionReducer;